import * as React from 'react';
import {CatalogPageEntity} from '../../../lib/Entity/CatalogPageEntity';

interface CatalogPageProps {
  page: CatalogPageEntity;
}

export class Page extends React.Component<CatalogPageProps, {}> {
  render() {
    const {page} = this.props;

    return (
      <div className='page-container'>
        <img src={page.img} alt='' className='img-responsive' />
      </div>
    );
  }
}
